var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { space, layout, typography, systemSxFromProps, } from '@revdotcom/vaporwave-system';
import { h1Sx, h2Sx, h3Sx, h4Sx, textSx, bodyMediumTextSx, bodyLargeTextSx, labelSmallTextSx, labelMediumTextSx, labelLargeTextSx, labelExtraLargeTextSx, formControlSmallSx, } from '@revdotcom/vaporwave-sx';
import { forwardCommonProps } from '../../Helpers/CommonProps';
var BuildText = function (_a) {
    var Component = _a.Component, typographyStyles = _a.typographyStyles;
    var VaporwaveText = function (_a) {
        var _b = _a.color, color = _b === void 0 ? 'text' : _b, _c = _a.display, display = _c === void 0 ? 'initial' : _c, _d = _a.variant, variant = _d === void 0 ? 'body-l' : _d, children = _a.children, rest = __rest(_a, ["color", "display", "variant", "children"]);
        var variantStyles = Component === 'p'
            ? variantTypographyStyles[variant]
            : typographyStyles;
        return (_jsx(Component, __assign({}, forwardCommonProps(rest), { sx: __assign(__assign({ color: color, display: display }, variantStyles), systemSxFromProps(rest, __spreadArray(__spreadArray(__spreadArray([], space, true), layout, true), typography, true))), children: children })));
    };
    return VaporwaveText;
};
var variantTypographyStyles = {
    'body-m': bodyMediumTextSx,
    'body-l': bodyLargeTextSx,
    'label-s': labelSmallTextSx,
    'label-m': labelMediumTextSx,
    'label-l': labelLargeTextSx,
    'label-xl': labelExtraLargeTextSx,
    'form-s': formControlSmallSx,
};
export var H1 = BuildText({
    Component: 'h1',
    typographyStyles: h1Sx,
});
export var H2 = BuildText({
    Component: 'h2',
    typographyStyles: h2Sx,
});
export var H3 = BuildText({
    Component: 'h3',
    typographyStyles: h3Sx,
});
export var H4 = BuildText({
    Component: 'h4',
    typographyStyles: h4Sx,
});
export var Text = BuildText({
    Component: 'p',
    typographyStyles: textSx,
});
// Redundant component to try to force a package update
export var H1B = BuildText({
    Component: 'h1',
    typographyStyles: h1Sx,
});
export var FormError = BuildText({
    Component: 'div',
    typographyStyles: formControlSmallSx,
});
